export const SIXTEEN_DAYS = 1382400;
export const TOTAL_RUNS = 'Total Test Runs';
export const TYPE_BROWSER = 'browsers';
export const TYPE_OS = 'oses';
export const TEST_OVERVIEW_DEFAULT_FILTER = { owners: ['Organization'] };
export const REQUEST_CANCEL_MESSAGE = 'REQUEST_CANCELED_BY_USER';
export const TEST_HISTORY_CANCEL_TOKEN_ID = 'TestHistoryContainer';
export const TEST_OVERVIEW_LAST_TEST_CASES_SIZE = 10;
export const ANALYTICS_CLOUDFRONT_URL = 'https://d3pvq2mh5vhc05.cloudfront.net';
